export default "__VITE_ASSET___CCVUfYk__"